import React, { FC, createContext, useCallback, useRef } from 'react'
import { useDispatch } from 'react-redux'

import networkActions from '../store/modules/network'

export const NewsletterContext = createContext({
  open: () => {},
})

export const NewsletterProvider: FC = ({
  children,
}) => {
  const dispatch = useDispatch()
  const scriptRef = useRef<any>()
  const open = useCallback(() => {
    dispatch(networkActions.setGlobalLoading({
      active: true,
    }))
    if(scriptRef.current) {
      document.head.removeChild(scriptRef.current)
    }
    document.cookie = 'MCPopupClosed=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;'
    document.cookie = 'MCPopupSubscribed=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;'
    const scriptTag = document.createElement('script')
    scriptTag.async = true
    scriptTag.src = 'https://chimpstatic.com/mcjs-connected/js/users/bcf34979ff008d730de71a1e6/2b1164bb98f7e9d6fbfb641af.js'
    document.head.append(scriptTag)
    scriptRef.current = scriptTag
    setTimeout(() => {
      dispatch(networkActions.setGlobalLoading({
        active: false,
      }))
    }, 1000)
  }, [])

  return (
    <NewsletterContext.Provider value={{
      open,
    }}>
      { children }
    </NewsletterContext.Provider>
  )
}

export default NewsletterContext